import {connect} from '@store/@common';
import {authUser} from '@store/auth';
import {
  libraryFormState,
  librarySources,
  librarySearchInfo,
  librarySearchCalls,
} from '@store/library';
import LibraryActions from 'actions/library/LibraryActions';
import CrmSyncActions from 'actions/crm/CrmSyncActions';

import {LibrarySearchForm} from './LibrarySearchForm';

const mapStateToProps = {
  user: authUser,
  searchInfo: librarySearchInfo,
  formState: libraryFormState,
  sources: librarySources,
  searchCalls: librarySearchCalls,
};

const mapDispatchToProps = {
  fetchLibrariesData: async () => {
    await Promise.all([
      CrmSyncActions.crmSupportsCloud(),
      LibraryActions.getLibraries(),
      LibraryActions.getTags(),
      LibraryActions.getRecentTags(),
      LibraryActions.getCommonTags(),
      LibraryActions.getShareItems(),
      LibraryActions.getShareAccessibleDepartments(),
      LibraryActions.getShareAccessibleTeams(),
    ]);
  },
  updateLibraryDropdown: LibraryActions.updateLibraryDropdown.defer,
};

export default connect(LibrarySearchForm, mapStateToProps, mapDispatchToProps);
